import Vue from "vue";
import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  CompanyState,
  ICompanyCreateRequest,
  ICompany,
  ICompanyListRequest
} from "@/types/company";
import axios from "axios";

export const actions: ActionTree<CompanyState, RootState> = {
  async adminGetList({ commit }, params: ICompanyListRequest) {
    try {
      const response = await axios.get<IPagination<ICompany[]>>(
        "/admin/company",
        {
          params
        }
      );

      commit("pagination", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },

  async adminGet({ commit }, companyId: number) {
    try {
      const response = await axios.get<ICompany>(`admin/company/${companyId}`);

      commit("single", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async adminGetMine({ commit }) {
    try {
      const response = await axios.get<ICompany>(`admin/company/mine`);

      commit("single", response.data);
      commit("error/resetError", null, { root: true });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
    }
  },
  async create({ commit }, params: ICompanyCreateRequest) {
    try {
      const response = await axios.post<ICompany>(`/company`, params);
      commit("single", response.data);
      commit("error/resetError", null, { root: true });
      Vue.prototype.$flashStorage.flash("仮登録完了", "success", {
        timeout: 3000,
        important: true
      });
      return true;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        commit("error/error", error.response.data, { root: true });
      }
      Vue.prototype.$flashStorage.flash(
        "作成失敗:入力内容を確認してください",
        "error",
        { timeout: 3000, important: true }
      );
      return false;
    }
  }
};

export default actions;
